import { IFilter } from '../../interfaces/filter.interface';

export class TextFilter implements IFilter<string | undefined> {
  private _filterValue: string | undefined;

  public update(value: string | undefined): void {
    this._filterValue = value;
  }

  public getFilterValue(): string | undefined {
    return this._filterValue;
  }
}
